import { WORKLOAD_REQUEST } from "../actions/utilities";

const INITIAL_STATE = {
  getSideBarLoading: false,
  getSideBarSuccess: false,
  getSideBarFailure: false,
  getsideBarError: null,
  employeesSidebarList: [],
  projectsSidebarList: [],

  getEmpWorkloadLoading: false,
  getEmpWorkloadSuccess: false,
  getEmpWorkloadFailure: false,
  getEmpWorkloadError: null,
  employeeWorkload: {},

  getEmployeeLoading: false,
  getEmployeeSuccess: false,
  getEmployeeFailure: false,
  getEmployeeError: null,
  getEmployee: [],

  getTaskListLoading: false,
  getTaskListSuccess: false,
  getTaskListFailure: false,
  getTaskListError: null,
  getTaskList: [],

  getProjectsLoading: false,
  getProjectsSuccess: false,
  getProjectsFailure: false,
  getProjectsError: null,
  getProjects: [],

  getEmployeeByUserIdLoading: false,
  getEmployeeByUserIdSuccess: false,
  getEmployeeByUserIdFailure: false,
  getEmployeeByUserIdError: null,
  getEmployeeByUserId: [],

  getTaskDetaileByUserIdLoading: false,
  getTaskDetaileByUserIdSuccess: false,
  getTaskDetaileByUserIdFailure: false,
  getTaskDetaileByUserIdError: null,
  getTaskDetaileByUserId: [],

  getEmployeeByProjectIdLoading: false,
  getEmployeeByProjectIdSuccess: false,
  getEmployeeByProjectIdFailure: false,
  getEmployeeByProjectIdError: null,
  getEmployeeByProjectId: [],

  postEmployeeCommentSuccess: false,
  postEmployeeCommentLoading: false,
  postEmployeeCommentFailure: false,
  postEmployeeCommentError: null,

  updateEmployeeCommentSuccess: false,
  updateEmployeeCommentLoading: false,
  updateEmployeeCommentFailure: false,
  updateEmployeeCommentError: null,

  getEmployeeCommentSuccess: false,
  getEmployeeCommentLoading: false,
  getEmployeeCommentFailure: false,
  getEmployeeCommentError: null,

  deleteEmployeeCommentSuccess: false,
  deleteEmployeeCommentLoading: false,
  deleteEmployeeCommentFailure: false,
  deleteEmployeeCommentError: null,
  comments: [],
};

export const workloadReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case WORKLOAD_REQUEST.GET_SIDBAR_REQUEST:
      return {
        ...state,
        getSideBarLoading: true,
        getSideBarSuccess: false,
        getSideBarFailure: false,
        getsideBarError: null,
        employeesSidebarList: [],
        projectsSidebarList: [],
      };
    case WORKLOAD_REQUEST.GET_SIDBAR_SUCCESS:
      return {
        ...state,
        getSideBarLoading: false,
        getSideBarSuccess: true,
        getSideBarFailure: false,
        getsideBarError: null,
        employeesSidebarList: action.payload.employeesSidebarList,
        projectsSidebarList: action.payload.projectsSidebarList,
      };

    case WORKLOAD_REQUEST.GET_EMPLOYEE_LIST_REQUEST:
      return {
        ...state,
        getEmployeeLoading: true,
        getEmployeeSuccess: false,
        getEmployeeFailure: false,
        getEmployeeError: null,
        getEmployee: [],
      };
    case WORKLOAD_REQUEST.GET_EMPLOYEE_LIST_SUCCESS:
      // //  ;
      return {
        ...state,
        getEmployeeLoading: false,
        getEmployeeSuccess: true,
        getEmployeeFailure: false,
        getEmployeeError: null,
        getEmployee: action.payload,
      };

    case WORKLOAD_REQUEST.GET_EMPLOYEE_BY_USER_ID_REQUEST:
      return {
        ...state,
        getEmployeeByUserIdLoading: true,
        getEmployeeByUserIdSuccess: false,
        getEmployeeByUserIdFailure: false,
        getEmployeeByUserIdError: null,
        getEmployeeByUserId: [],
      };
    case WORKLOAD_REQUEST.GET_EMPLOYEE_BY_USER_ID_SUCCESS:
      return {
        ...state,
        getEmployeeByUserIdLoading: false,
        getEmployeeByUserIdSuccess: true,
        getEmployeeByUserIdFailure: false,
        getEmployeeByUserIdError: null,
        getEmployeeByUserId: action.payload,
      };
    case WORKLOAD_REQUEST.GET_EMPLOYEE_BY_USER_ID_FAILURE:
      return {
        ...state,
        getEmployeeByUserIdLoading: false,
        getEmployeeByUserIdSuccess: false,
        getEmployeeByUserIdFailure: true,
        getEmployeeByUserIdError: action.payload,
      };
    case WORKLOAD_REQUEST.GET_EMPLOYEE_BY_PROJECT_ID_REQUEST:
      return {
        ...state,
        getEmployeeByProjectIdLoading: true,
        getEmployeeByProjectIdSuccess: false,
        getEmployeeByProjectIdFailure: false,
        getEmployeeByProjectIdError: null,
        getEmployeeByProjectId: [],
      };
    case WORKLOAD_REQUEST.GET_EMPLOYEE_BY_PROJECT_ID_SUCCESS:
      return {
        ...state,
        getEmployeeByProjectIdLoading: false,
        getEmployeeByProjectIdSuccess: true,
        getEmployeeByProjectIdFailure: false,
        getEmployeeByProjectIdError: null,
        getEmployeeByProjectId: action.payload,
      };
    case WORKLOAD_REQUEST.GET_EMPLOYEE_BY_PROJECT_ID_FAILURE:
      return {
        ...state,
        getEmployeeByProjectIdLoading: false,
        getEmployeeByProjectIdSuccess: false,
        getEmployeeByProjectIdFailure: true,
        getEmployeeByProjectIdError: action.payload,
      };

    case WORKLOAD_REQUEST.GET_TASK_LIST_REQUEST:
      return {
        ...state,
        getTaskListLoading: true,
        getTaskListSuccess: false,
        getTaskListFailure: false,
        getTaskListError: null,
        getTaskList: [],
      };
    case WORKLOAD_REQUEST.GET_TASK_LIST_SUCCESS:
      // //  ;
      return {
        ...state,
        getTaskListLoading: false,
        getTaskListSuccess: true,
        getTaskListFailure: false,
        getTaskListError: null,
        getTaskList: action.payload,
      };
    case WORKLOAD_REQUEST.GET_TASK_LIST_FAILURE:
      return {
        ...state,
        getTaskListLoading: false,
        getTaskListSuccess: false,
        getTaskListFailure: true,
        getTaskListError: action.payload,
      };

    case WORKLOAD_REQUEST.GET_PROJECT_LIST_REQUEST:
      return {
        ...state,
        getProjectLoading: true,
        getProjectSuccess: false,
        getProjectFailure: false,
        getProjectError: null,
        getProject: [],
      };
    case WORKLOAD_REQUEST.GET_PROJECT_LIST_SUCCESS:
      // debugger
      return {
        ...state,
        getProjectLoading: false,
        getProjectSuccess: true,
        getProjectFailure: false,
        getProjectError: null,
        getProject: action.payload,
      };
    case WORKLOAD_REQUEST.GET_PROJECT_LIST_FAILURE:
      return {
        ...state,
        getProjectLoading: false,
        getProjectSuccess: false,
        getProjectFailure: true,
        getProjectError: action.payload,
      };

    case WORKLOAD_REQUEST.GET_EMPWORKLOAD_REQUEST:
      return {
        ...state,
        getEmpWorkloadLoading: true,
        getEmpWorkloadSuccess: false,
        getEmpWorkloadFailure: false,
        getEmpWorkloadError: null,
        employeeWorkload: {},
      };
    case WORKLOAD_REQUEST.GET_EMPWORKLOAD_SUCCESS:
      return {
        ...state,
        getEmpWorkloadLoading: false,
        getEmpWorkloadSuccess: true,
        getEmpWorkloadFailure: false,
        getEmpWorkloadError: null,
        employeeWorkload: action.payload,
      };
    case WORKLOAD_REQUEST.GET_EMPWORKLOAD_FAILURE:
      return {
        ...state,
        getEmpWorkloadLoading: false,
        getEmpWorkloadSuccess: false,
        getEmpWorkloadFailure: true,
        getEmpWorkloadError: action.payload,
      };
    case WORKLOAD_REQUEST.GET_TASK_DETAILE_BY_USER_ID_REQUEST:
      return {
        ...state,
        getTaskDetaileByUserIdLoading: true,
        getTaskDetaileByUserIdSuccess: false,
        getTaskDetaileByUserIdFailure: false,
        getTaskDetaileByUserIdError: null,
        getTaskDetaileByUserId: [],
      };
    case WORKLOAD_REQUEST.GET_TASK_DETAILE_BY_USER_ID_SUCCESS:
      return {
        ...state,
        getTaskDetaileByUserIdLoading: false,
        getTaskDetaileByUserIdSuccess: true,
        getTaskDetaileByUserIdFailure: false,
        getTaskDetaileByUserIdError: null,
        getTaskDetaileByUserId: action.payload,
      };
    case WORKLOAD_REQUEST.GET_TASK_DETAILE_BY_USER_ID_FAILURE:
      return {
        ...state,
        getTaskDetaileByUserIdLoading: false,
        getTaskDetaileByUserIdSuccess: false,
        getTaskDetaileByUserIdFailure: true,
        getTaskDetaileByUserIdError: action.payload,
        getTaskDetaileByUserId: [],
      };

    case WORKLOAD_REQUEST.POST_EMPLOYEE_COMMENT_REQUEST:
      return {
        ...state,
        postEmployeeCommentSuccess: false,
        postEmployeeCommentLoading: true,
        postEmployeeCommentFailure: false,
        postEmployeeCommentError: null,
      };

    case WORKLOAD_REQUEST.POST_EMPLOYEE_COMMENT_SUCCESS:
      var indexInfo = action.info;
      let postComment = action.payload;
      let previousComments = state.getTaskDetaileByUserId;
      if (postComment.parentId && postComment.parentId > 0) {
        for (var i = 0; i < previousComments.length; i++) {
          if (previousComments[i].taskId == postComment.taskId) {
            let reply = previousComments[i].comments[indexInfo.commentIndex];
            if (reply?.replies == null) {
              reply.replies = [];
            }

            if (
              reply.replies[indexInfo.replyIndex]?.commentId ===
              postComment.commentId
            ) {
              reply.replies[indexInfo.replyIndex] = postComment;
            } else {
              reply.replies?.push(postComment);
              let result = previousComments[i].comments[indexInfo.commentIndex];
              result.replies = reply.replies;
            }
          }
        }
      } else {
        for (var index in previousComments) {
          if (previousComments[index].taskId == postComment.taskId) {
            if (previousComments[index].comments === null) {
              previousComments[index].comments = [];
            }
            let com = previousComments[index].comments[indexInfo.commentIndex];
            if (com?.commentId === postComment.commentId) {
              previousComments[index].comments[indexInfo.commentIndex].comment =
                postComment.comment;
            } else {
              if (previousComments[index].comments === null) {
                previousComments[index].comments = [];
                previousComments[index].comments?.push(postComment);
              } else {
                previousComments[index].comments?.push(postComment);
              }
            }
          }
        }
      }

      return {
        ...state,
        postEmployeeCommentSuccess: true,
        postEmployeeCommentLoading: false,
        postEmployeeCommentFailure: false,
        postEmployeeCommentError: null,
      };

    case WORKLOAD_REQUEST.POST_EMPLOYEE_COMMENT_FAILURE:
      return {
        ...state,
        postEmployeeCommentSuccess: false,
        postEmployeeCommentLoading: false,
        postEmployeeCommentFailure: true,
        postEmployeeCommentError: action.payload,
      };
    // case WORKLOAD_REQUEST.UPDATE_EMPLOYEE_COMMENT_REQUEST:
    //   return {
    //     ...state,
    //     updateEmployeeCommentSuccess: false,
    //     updateEmployeeCommentLoading: true,
    //     updateEmployeeCommentFailure: false,
    //     updateEmployeeCommentError: null,
    //   };

    // case WORKLOAD_REQUEST.UPDATE_EMPLOYEE_COMMENT_SUCCESS:
    //   let editComment = action.payload;
    //   let userComments = state.getTaskDetaileByUserId;
    //   for (var i = 0; i < userComments.length; i++) {
    //     for (var j = 0; j < userComments[i].comments?.length; j++) {
    //       if (userComments[i].comments[j].commentId == editComment) {
    //         userComments[i].comments?.splice(j, 1);
    //       }
    //     }
    //   }
    //   return {
    //     ...state,
    //     updateEmployeeCommentSuccess: true,
    //     updateEmployeeCommentLoading: false,
    //     updateEmployeeCommentFailure: false,
    //     updateEmployeeCommentError: null,
    //   };

    // case WORKLOAD_REQUEST.UPDATE_EMPLOYEE_COMMENT_FAILURE:
    //   return {
    //     ...state,
    //     updateEmployeeCommentSuccess: false,
    //     updateEmployeeCommentLoading: false,
    //     updateEmployeeCommentFailure: true,
    //     updateEmployeeCommentError: action.payload,
    //   };

    case WORKLOAD_REQUEST.GET_EMPLOYEE_COMMENT_REQUEST:
      return {
        ...state,
        getEmployeeCommentSuccess: false,
        getEmployeeCommentLoading: true,
        getEmployeeCommentFailure: false,
        getEmployeeCommentError: null,
      };

    case WORKLOAD_REQUEST.GET_EMPLOYEE_COMMENT_SUCCESS:
      return {
        ...state,
        getEmployeeCommentSuccess: true,
        getEmployeeCommentLoading: false,
        getEmployeeCommentFailure: false,
        getEmployeeCommentError: null,
      };

    case WORKLOAD_REQUEST.GET_EMPLOYEE_COMMENT_FAILURE:
      return {
        ...state,
        getEmployeeCommentSuccess: false,
        getEmployeeCommentLoading: false,
        getEmployeeCommentFailure: true,
        getEmployeeCommentError: action.payload,
      };

    case WORKLOAD_REQUEST.DELETE_EMPLOYEE_COMMENT_REQUEST:
      return {
        ...state,
        deleteEmployeeCommentSuccess: false,
        deleteEmployeeCommentLoading: true,
        deleteEmployeeCommentFailure: false,
        deleteEmployeeCommentError: null,
      };

    case WORKLOAD_REQUEST.DELETE_EMPLOYEE_COMMENT_SUCCESS:
      let delComment = action.payload;
      let delindex = action.info;
      let taskComments = state.getTaskDetaileByUserId;
      for (var i = 0; i < taskComments.length; i++) {
        if (taskComments[i]?.comments === null) {
          taskComments[i].comments = [];
        }
        let delreply = taskComments[i]?.comments[delindex?.commentIndex];
        if (delreply?.commentId == delComment) {
          taskComments[i]?.comments?.splice(delindex?.commentIndex, 1);
        } else {
          delreply?.replies?.splice(delindex?.replyIndex, 1);
        }
      }
      return {
        ...state,
        deleteEmployeeCommentSuccess: true,
        deleteEmployeeCommentLoading: false,
        deleteEmployeeCommentFailure: false,
        deleteEmployeeCommentError: null,
      };

    case WORKLOAD_REQUEST.DELETE_EMPLOYEE_COMMENT_FAILURE:
      return {
        ...state,
        deleteEmployeeCommentSuccess: false,
        deleteEmployeeCommentLoading: false,
        deleteEmployeeCommentFailure: true,
        deleteEmployeeCommentError: action.payload,
      };
    default:
      return state;
  }
};
